import { t } from 'i18next';
import { FC, useEffect, useRef, useState } from 'react';
import { useAccountCreationContext } from '../../../common/context/AccountCreationContext';
// import { getTypeLabelLongFromSubcategory } from '../../../common/data/getTypeLabelLongFromSubcategory';
import { fetchProductModels } from '../../../api/products/fetchProductModels';
import { getTypeCategoryFromDisplay } from '../../../common/data/getTypeCategoryFromDisplay';
import { getTypeSubcategoryFromCategory } from '../../../common/data/getTypeSubcategoryFromCategory';
import { Brand } from '../../../common/types';
import { trackEvent } from '../../../common/utils/analytics';
import ProductButton from '../../buttons/ProductButton';
import PrimaryParagraph from '../../texts/PrimaryParagraph';
import PrimaryTitle from '../../texts/PrimaryTitle';
// import PopsizeSpinningLoaderLarge from '../../loader/PopsizeSpinningLoaderLarge';
import { getGenderStringFromCode } from '../../../api/users/genderMapping';
import { getCachedProducts, setCachedProducts } from '../../../common/cache/ProductPrefetchCache';
import PopsizeSpinningLoaderMedium from '../../loader/PopsizeSpinningLoaderMedium';

const ProductSelectionView: FC<{
	modalIsOpen: boolean;
	productModels: any[];
	modalWidth?: number;
	modalHeight?: number;
	handleProductSelect: (product: any) => void;
	brand: Brand;
	handleBackStep?: () => void;
	handlePreviousBrand?: () => void;
	brandIndex: number;
	typeLabelDisplay: string;
	selectedProduct: any | null;
}> = ({ productModels, modalWidth, modalHeight, handleProductSelect, brand, handleBackStep, handlePreviousBrand, brandIndex, typeLabelDisplay, selectedProduct }) => {
	const { raw: rawTypeCategory } = getTypeCategoryFromDisplay(typeLabelDisplay || '');
	const subcategoryOptions = rawTypeCategory ? getTypeSubcategoryFromCategory(rawTypeCategory) : [];
	const [selectedSubcategory, setSelectedSubcategory] = useState<{ raw: string } | null>(
		subcategoryOptions.length > 0 ? subcategoryOptions[0] : null
	);
	const [filteredProducts, setFilteredProducts] = useState<any[]>([]);
	const { shoppingPreference } = useAccountCreationContext();
	const abortControllerRef = useRef<AbortController | null>(null);
	const [isLoading, setIsLoading] = useState(true);
	const [showSpinner, setShowSpinner] = useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
		if (!selectedSubcategory?.raw || !brand.code) return;

		// Cancel any ongoing request
		if (abortControllerRef.current) {
			abortControllerRef.current.abort();
		}
		const controller = new AbortController();
		abortControllerRef.current = controller;

		const cached = getCachedProducts(brand.code, selectedSubcategory.raw);
		if (cached && cached.length > 0) {
			setFilteredProducts(cached);
			setIsLoading(false);
			setShowSpinner(false);
			return;
		}

		setIsLoading(true);
		setShowSpinner(false);

		const spinnerTimeout = setTimeout(() => {
			setShowSpinner(true);
		}, 500);

		const fetchTimeout = setTimeout(() => {
			console.warn('⏳ Fetch timeout after 30 seconds');
			controller.abort();
			setFilteredProducts([]);
			setIsLoading(false);
			setShowSpinner(false);
		}, 60_000); 

		setFilteredProducts([]);

		fetchProductModels({
			userUid: null,
			brandCode: brand.code,
			typeLabelLong: '',
			type_category: rawTypeCategory ?? '',
			type_subcategory: selectedSubcategory.raw,
			query: '',
			gender_label: getGenderStringFromCode(shoppingPreference || ''),
			signal: controller.signal,
		})
		.then(({ models }) => {
			setFilteredProducts(models);
			setCachedProducts(brand.code, selectedSubcategory.raw, models);
		})
		.catch((err) => {
			console.error('❌ Failed to fetch product models:', err);
		})
		.finally(() => {
			clearTimeout(spinnerTimeout);
			clearTimeout(fetchTimeout);
			setIsLoading(false);
			setShowSpinner(false);
		});

		return () => {
			clearTimeout(spinnerTimeout);
			clearTimeout(fetchTimeout);
			controller.abort();
		};
  }, [selectedSubcategory?.raw, brand.code, shoppingPreference]);
	
	return (
		<div className="pop-h-full pop-fadeIn pop-w-full pop-my-4">
			<div className="pop-flex pop-items-center pop-justify-between pop-w-full pop-mb-4">
				<div className="pop-w-[10%] pop-justify-center pop-items-start">
						{brandIndex > 0 && (
						<button
							onClick={handlePreviousBrand}
							className="pop-flex pop-items-center pop-gap-2 pop-text-sm pop-text-popsizePrimary50"
						>
							<span className="pop-text-lg pop-font-bold">&lt;</span>
							{t('previous')}
						</button>
					)}
				</div>
				<PrimaryTitle className="pop-w-full pop-items-center pop-justify-center pop-text-center">{t('product_question')} {brand.name}?</PrimaryTitle>
				<div className="pop-w-[10%]">
						{brand && (
							brand.faviconUrl ? (
								<img
								className="pop-w-6 pop-h-6"
								src={brand.faviconUrl}
								alt="favicon"
								/>
							) : brand.image ? (
								<img
								className="pop-w-6 pop-h-auto"
								src={`${process.env.REACT_APP_GCP_BUCKET_URL}/images/brand-logos/${brand.image}`}
								alt={brand.name}
								/>
							) : (
								<div className="pop-text-xs pop-text-popsizePrimary50 pop-text-center">
								{brand.name || ''}
								</div>
							)
							)}
					</div>
					</div>
					<div>
				{/* <PrimaryParagraph className={'pop-text-center pop-mb-4'}>
					{t('product_select_message')} {brand.name}
				</PrimaryParagraph> */}

				{/*<div className="pop-relative pop-w-full pop-mb-12">
					<div className="pop-absolute pop-left-0 pop-top-1/2 -pop-translate-y-1/2">
						{brandIndex > 0 && (
						<button
							onClick={handlePreviousBrand}
							className="pop-flex pop-items-center pop-gap-2 pop-text-sm pop-text-popsizePrimary50"
						>
							<span className="pop-text-lg pop-font-bold">&lt;</span>
							{t('previous')}
						</button>
						)}
					</div>*/}

					{/*<div className="pop-flex pop-justify-center pop-items-center pop-h-full">
						{brand && (
							brand.faviconUrl ? (
								<img
								className="pop-w-6 pop-h-6"
								src={brand.faviconUrl}
								alt="favicon"
								/>
							) : brand.image ? (
								<img
								className="pop-w-6 pop-h-auto"
								src={`${process.env.REACT_APP_GCP_BUCKET_URL}/images/brand-logos/${brand.image}`}
								alt={brand.name}
								/>
							) : (
								<div className="pop-text-xs pop-text-popsizePrimary50 pop-text-center">
								{brand.name || ''}
								</div>
							)
							)}
					</div>*/}
				</div>

				{/* Subcategory Filters */}
				<div
					className="pop-flex pop-flex-wrap pop-justify-center pop-gap-2 pop-mb-4 pop-w-full max-w-[900px]"
				>
					{subcategoryOptions.map((subcat, index) => {
						const isActive = subcat.raw === selectedSubcategory?.raw;
						const localizedLabel = t(`type_subcategory.${subcat.raw}`);

						return (
							<div
								key={index}
								onClick={() => {
									setSelectedSubcategory(subcat);
									trackEvent('product_subcategory_viewed', { subcategory: subcat.raw });
								}}
								className={`pop-px-2 pop-py-1 pop-rounded-full pop-text-xs pop-cursor-pointer
									${isActive
										? 'pop-border-2 pop-border-popsizeSecondary90 pop-bg-popsizePrimary90 pop-text-popsizePrimary10'
										: 'pop-border-1 pop-border-popsizePrimary50 pop-text-popsizePrimary90'
									}`}
								style={
									isActive
										? {}
										: {
											backgroundImage: 'linear-gradient(to bottom right, #F7FAFF, #FFFCF7)',
										}
								}
							>
								{localizedLabel}
							</div>
						);
					})}
				</div>

				{/* Spinner or Products */}
				{isLoading && showSpinner ? (
					<div className="pop-my-10">
					<PopsizeSpinningLoaderMedium username={''} />
					</div>
				) : !isLoading && filteredProducts.length === 0 ? (
					<div
					className="pop-flex pop-justify-center pop-w-full"
					>
					<p className="pop-text-popsizePrimary90 pop-text-center pop-my-4 pop-font-semibold">
						{t('no_products_message') || 'Sorry, there is no product.'}
					</p>
					</div>
				) : (
					<div className="pop-grid pop-grid-cols-4 pop-mb-16">
					{filteredProducts.map((product, index) => (
						<ProductButton
							key={index}
							productLabel={product.product_label}
							productImages={product.product_images || []}
							isSelected={selectedProduct?.firestore_id === product.firestore_id}
							onSelect={() => { trackEvent('product_selected'); handleProductSelect(product); }}
							height={150}
							width={150}
						/>
					))}	
				</div>
				)}
			</div>

	);
};

export default ProductSelectionView;
